// extracted by mini-css-extract-plugin
module.exports = {"newsBannerWrapper":"NewsBanner_component_newsBannerWrapper__ZyM63"};